import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from 'antd'

const EditorContainer = styled.div`
  border: 1px solid #eaecf0;
  border-radius: 8px;
  background: #ffffff;
  position: relative;
`

const Toolbar = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px;
  border-bottom: 1px solid #eaecf0;
`

const ToolButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #d0d5dd;
  background: white;

  &:hover {
    background: #f9fafb;
  }

  &.active {
    background: #f0f3ff;
    border-color: #1570ef;
  }
`

const Divider = styled.div`
  width: 1px;
  height: 24px;
  background: #eaecf0;
  margin: 0 4px;
`

const FontSizeButton = styled(Button)`
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border: 1px solid #d0d5dd;
  background: white;
  font-size: 14px;

  &:hover {
    background: #f9fafb;
  }
`

const EditorContent = styled.div`
  padding: 16px;
  min-height: 400px;
  font-size: 14px;
  line-height: 20px;
  color: #101828;

  &:focus {
    outline: none;
  }
`

const TextEditor = ({ initialContent, onSave }) => {
  const [content, setContent] = useState(initialContent)

  const handleBold = () => {
    document.execCommand('bold', false, null)
  }

  const handleItalic = () => {
    document.execCommand('italic', false, null)
  }

  const handleUnderline = () => {
    document.execCommand('underline', false, null)
  }

  const handleBulletList = () => {
    document.execCommand('insertUnorderedList', false, null)
  }

  const handleNumberList = () => {
    document.execCommand('insertOrderedList', false, null)
  }

  const handleFontSizeDecrease = () => {
    document.execCommand('fontSize', false, '2')
  }

  const handleFontSizeIncrease = () => {
    document.execCommand('fontSize', false, '4')
  }

  const handleSave = () => {
    onSave?.(content)
  }

  const handleKeyDown = e => {
    // Save on Ctrl+S
    if ((e.ctrlKey || e.metaKey) && e.key === 's') {
      e.preventDefault()
      handleSave()
    }
    // Close on Escape
    if (e.key === 'Escape') {
      e.preventDefault()
      onClose?.()
    }
  }

  return (
    <EditorContainer>
      <Toolbar>
        <ToolButton onClick={handleBold} title="Bold">
          B
        </ToolButton>
        <ToolButton onClick={handleItalic} title="Italic">
          I
        </ToolButton>
        <ToolButton onClick={handleUnderline} title="Underline">
          U
        </ToolButton>
        <Divider />
        <ToolButton onClick={handleBulletList} title="Bullet List">
          •
        </ToolButton>
        <ToolButton onClick={handleNumberList} title="Number List">
          1.
        </ToolButton>
        <Divider />
        <FontSizeButton
          onClick={handleFontSizeDecrease}
          title="Decrease Font Size"
        >
          A-
        </FontSizeButton>
        <FontSizeButton
          onClick={handleFontSizeIncrease}
          title="Increase Font Size"
        >
          A+
        </FontSizeButton>
        <Divider />
      </Toolbar>
      <EditorContent
        contentEditable
        dangerouslySetInnerHTML={{ __html: content }}
        onInput={e => {
          const newContent = e.currentTarget.innerHTML
          setContent(newContent)
        }}
        onKeyDown={handleKeyDown}
      />
    </EditorContainer>
  )
}

export default TextEditor
